import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMessages,
  markAllAsRead,
  markAsDelete,
} from "./cl_MessageCenterSlice";
import PaginationComponent from "../common/PaginationComponent";

const MessageCenter = () => {
  const dispatch = useDispatch();
  const { messageCenterData } = useSelector((state) => state?.messages);
  const [isDelete, setIsDelete] = useState(false);
  useEffect(() => {
    dispatch(fetchMessages());
  }, []);
  useEffect(() => {
    // console.log(messageCenterData, "messageCenterData=========");
  }, [messageCenterData]);
  const deleteRequest = () => {
    setIsDelete(!isDelete);
  };
  const deleteNotification = () => {
    dispatch(markAsDelete());
    setIsDelete(!isDelete);
  };
  const markAllAsReadNotification = () => {
    dispatch(markAllAsRead());
  };
  return (
    <React.Fragment>
      <div className="SB-myAccountSection-container SB-messageCenter">
        <div className="SB-pageHeader">
          <div className="SB-pageHeader-title">Messages</div>
        </div>
        <div className="SB-messageCenter-container">
          <div className="SB-messageCenter-filters SB-row">
            <div className="SB-messageCenter-filters__left SB-col">
              <div className="SB-search">
                <div className="SB-searchBox">
                  <div className="SB-searchButton">
                    {/* <!-- <span className="sb-icon icon-search"></span> --> */}
                    <div className="SB-iconSVG">
                      <svg xmlns="http://www.w3.org/2000/svg">
                        <use xlinkHref={`${icons}#${"icon-search"}`}></use>
                      </svg>
                    </div>
                  </div>
                  <input type="text" placeholder="Search" />
                  <span className="sb-icon icon-close"></span>
                </div>
              </div>
            </div>
            <div className="SB-messageCenter-filters__right SB-col">
              <div className="SB-actionFilters">
                <div
                  className="SB-readAllBtn active"
                  onClick={markAllAsReadNotification}
                >
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"mark-as-read"}`}></use>
                    </svg>
                  </div>
                  <span>Mark all as aread</span>
                </div>
                {/* <!-- <div className="SB-deleteAll" data-toggle="modal"
                                                data-target="#SB-msgDelete-modal">
                                                <div className="SB-iconSVG">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xlinkHref="images/sprite-other-icons.svg#icon-trash">
                                                        </use>
                                                    </svg>
                                                </div>
                                                <span>Delete</span>
                                            </div>
                                            <div className="SB-selectAll">
                                                <div className="SB-checkbox">
                                                    <input id="selectAllCheckbox" name="" value="" type="checkbox">
                                                    <label for="selectAllCheckbox"><span className="SB-checkboxLabel">Select
                                                            All</span></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
          </div>
          <div className="SB-msgCenter-item__group">
            <div className="SB-msgCenter-item unread SB-success">
              <div
                className="SB-msgCenter-item__content"
                // onClick="window.location.href='message-center-details.html';"
              >
                <div className="SB-msgCenter-item__icon SB-iconSVG ">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-withdraw"}`}></use>
                  </svg>
                </div>
                <div className="SB-msgCenter-item__body">
                  <div className="SB-contentBlock">
                    <div className="SB-msgCenter-item__id SB-leftContent">
                      ID: 1691044
                    </div>
                    <div className="SB-msgCenter-item__dateTime SB-rightContent">
                      10mins ago
                    </div>
                  </div>
                  <div className="SB-msgCenter-item__subject">
                    Withdraw Success!
                  </div>
                  <div className="SB-msgCenter-item__msg">
                    Withdraw Success! Deposit Amount: 100.0
                  </div>
                </div>
              </div>
              <div className="SB-msgCenter-item__actions">
                <div
                  className="SB-msgCenter-item__delete SB-iconSVG"
                  onClick={deleteRequest}
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-trash"}`}></use>
                  </svg>
                </div>
                {/* 
                                            <!-- <div className="SB-msgCenter-item__select">
                                                <div className="SB-checkbox">
                                                    <input id="selectCheckbox1" name="" value="" type="checkbox">
                                                    <label for="selectCheckbox1"></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
            <div className="SB-msgCenter-item unread SB-success SB-msgSelected">
              <div
                className="SB-msgCenter-item__content"
                // onClick="window.location.href='message-center-details.html';"
              >
                <div className="SB-msgCenter-item__icon SB-iconSVG ">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-deposit"}`}></use>
                  </svg>
                </div>
                <div className="SB-msgCenter-item__body">
                  <div className="SB-contentBlock">
                    <div className="SB-msgCenter-item__id SB-leftContent">
                      ID: 1691044
                    </div>
                    <div className="SB-msgCenter-item__dateTime SB-rightContent">
                      2hrs ago
                    </div>
                  </div>
                  <div className="SB-msgCenter-item__subject">
                    Deposit Success!
                  </div>
                  <div className="SB-msgCenter-item__msg">
                    Deposit Success! Deposit Amount: 100.0 TransactonId :
                    MANUALPAYMENT
                  </div>
                </div>
              </div>
              <div className="SB-msgCenter-item__actions">
                <div
                  className="SB-msgCenter-item__delete SB-iconSVG"
                  data-toggle="modal"
                  data-target="#SB-msgDelete-modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-trash"}`}></use>
                  </svg>
                </div>
                {/* 
                                            <!-- <div className="SB-msgCenter-item__select">
                                                <div className="SB-checkbox">
                                                    <input id="selectCheckbox2" name="" value="" type="checkbox"
                                                        checked>
                                                    <label for="selectCheckbox2"></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
            <div className="SB-msgCenter-item SB-fail">
              <div
                className="SB-msgCenter-item__content"
                // onClick="window.location.href='message-center-details.html';"
              >
                <div className="SB-msgCenter-item__icon SB-iconSVG ">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-alert"}`}></use>
                  </svg>
                </div>
                <div className="SB-msgCenter-item__body">
                  <div className="SB-contentBlock">
                    <div className="SB-msgCenter-item__id SB-leftContent">
                      ID: 1691044
                    </div>
                    <div className="SB-msgCenter-item__dateTime SB-rightContent">
                      Yesterday
                    </div>
                  </div>
                  <div className="SB-msgCenter-item__subject">
                    Withdraw Success!
                  </div>
                  <div className="SB-msgCenter-item__msg">
                    Withdraw Success! Deposit Amount: 100.0
                  </div>
                </div>
              </div>
              <div className="SB-msgCenter-item__actions">
                <div
                  className="SB-msgCenter-item__delete SB-iconSVG"
                  data-toggle="modal"
                  data-target="#SB-msgDelete-modal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-trash"}`}></use>
                  </svg>
                </div>

                {/* <!-- <div className="SB-msgCenter-item__select">
                                                <div className="SB-checkbox">
                                                    <input id="selectCheckbox3" name="" value="" type="checkbox">
                                                    <label for="selectCheckbox3"></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
            <div className="SB-msgCenter-item SB-fail">
              <div
                className="SB-msgCenter-item__content"
                // onClick="window.location.href='message-center-details.html';"
              >
                <div className="SB-msgCenter-item__icon SB-iconSVG ">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-alert"}`}></use>
                  </svg>
                </div>
                <div className="SB-msgCenter-item__body">
                  <div className="SB-contentBlock">
                    <div className="SB-msgCenter-item__id SB-leftContent">
                      ID: 1691044
                    </div>
                    <div className="SB-msgCenter-item__dateTime SB-rightContent">
                      10-11-2023
                    </div>
                  </div>
                  <div className="SB-msgCenter-item__subject">
                    Deposit Failed!
                  </div>
                  <div className="SB-msgCenter-item__msg">
                    Deposit Failed! deposit amount: 100.0 Transaction Id :
                    TNX-00008ZON
                  </div>
                </div>
              </div>
              <div className="SB-msgCenter-item__actions">
                <div className="SB-msgCenter-item__delete SB-iconSVG">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-trash"}`}></use>
                  </svg>
                </div>

                {/* <!-- <div className="SB-msgCenter-item__select">
                                                <div className="SB-checkbox">
                                                    <input id="selectCheckbox4" name="" value="" type="checkbox">
                                                    <label for="selectCheckbox4"></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
            <div className="SB-msgCenter-item unread SB-success">
              <div
                className="SB-msgCenter-item__content"
                // onClick="window.location.href='message-center-details.html';"
              >
                <div className="SB-msgCenter-item__icon SB-iconSVG ">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-withdraw"}`}></use>
                  </svg>
                </div>
                <div className="SB-msgCenter-item__body">
                  <div className="SB-contentBlock">
                    <div className="SB-msgCenter-item__id SB-leftContent">
                      ID: 1691044
                    </div>
                    <div className="SB-msgCenter-item__dateTime SB-rightContent">
                      02-10-2023
                    </div>
                  </div>
                  <div className="SB-msgCenter-item__subject">
                    Withdraw Success!
                  </div>
                  <div className="SB-msgCenter-item__msg">
                    Withdraw Success! Deposit Amount: 100.0
                  </div>
                </div>
              </div>
              <div className="SB-msgCenter-item__actions">
                <div className="SB-msgCenter-item__delete SB-iconSVG">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-trash"}`}></use>
                  </svg>
                </div>

                {/* <!-- <div className="SB-msgCenter-item__select">
                                                <div className="SB-checkbox">
                                                    <input id="selectCheckbox5" name="" value="" type="checkbox"/>
                                                    <label for="selectCheckbox5"></label>
                                                </div>
                                            </div> --> */}
              </div>
            </div>
          </div>
          <PaginationComponent />
        </div>
      </div>
      {isDelete && (
        <div
          className={`SB-modal SB-msgDelete-modal ${
            isDelete ? "show" : "hide"
          }`}
          id="SB-msgDelete-modal"
          style={{ display: "block", paddingRight: "0px" }}
          aria-modal="true"
          role="dialog"
        >
          <div className="SB-modal-dialog">
            <div className="SB-modal-content">
              <div
                className="SB-modal-close"
                onClick={deleteRequest}
                data-dismiss="modal"
              >
                <span className="sb-icon icon-close"></span>
              </div>
              <div className="SB-modal-innerContent">
                <div className="SB-content text-center">
                  <div className="SB-SB-msgDelete-modal__icon SB-iconSVG ">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close-circle"}`}></use>
                    </svg>
                  </div>
                  <h2>Are you sure?</h2>

                  <div>Do you really want to delete this message</div>
                  <div className="SB-space20"></div>
                </div>
              </div>
              <div className="SB-modal-footer">
                <div className="SB-btnYesNoContainer">
                  <button
                    className="btn SB-btnDefault active SB-btnMedium SB-btnNo"
                    onClick={deleteRequest}
                  >
                    No
                  </button>
                  <button
                    className="btn SB-btnSecondary active SB-btnMedium SB-btnYes"
                    onClick={deleteNotification}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MessageCenter;
